import React, { Component, Fragment } from "react";
import ReactDOM from "react-dom";
// import { Rnd } from 'react-rnd'
import Header from "./Components/Header";
import DesignContainer from "./Components/DesignContainer";

class App extends Component {
  constructor() {
    super();
    this.state = {
      scenes: []
    };
  }
  updateScene(scenes) {
    this.setState({
      scenes: scenes
    });
    console.log("Yo scen");
  }
  render() {
    return (
      <div id="container">
        <Header scenes={this.state.scenes} />
        <DesignContainer updateScene={this.updateScene.bind(this)} />
      </div>
    );
  }
}

export default App;
